import * as React from 'react';
import { useMessage } from '../messages/useMessage';
import { useEmailService } from '../services/email-service';

export const useEmailController = () => {
  const {
    sendEmailSubscriptionSvc,
    sendEmailResultSvc,
    sendEmailReeinterview,
  } = useEmailService();
  const { handleError, handleSuccess } = useMessage();

  const sendEmailSubscription = React.useCallback(
    async (params) => {
      try {
        const data = await sendEmailSubscriptionSvc(params);
        const resultText =
          params.sendAll || params.idsInterviews?.length > 1
            ? 'E-mails enviados com sucesso!'
            : 'E-mail enviado com sucesso!';
        handleSuccess(resultText);
        return data;
      } catch (error) {
        console.error(error);
        handleError('Erro ao tentar enviar os e-mails de inscrição');
      }
    },
    [handleError, handleSuccess, sendEmailSubscriptionSvc],
  );

  const sendEmailResult = React.useCallback(
    async (idsInterviews) => {
      try {
        const data = await sendEmailResultSvc(idsInterviews);
        handleSuccess('E-mail enviado com sucesso!');
        return data;
      } catch (error) {
        console.error(error);
        handleError('Erro ao tentar enviar os e-mails de resultados');
      }
    },
    [handleError, handleSuccess, sendEmailResultSvc],
  );

  const enviarEmailReentrevista = React.useCallback(
    async (id) => {
      try {
        const data = await sendEmailReeinterview(id);
        handleSuccess('E-mail enviado com sucesso!');
        return data;
      } catch (error) {
        console.error(error);
        handleError('Erro ao tentar enviar o e-mail de reentrevista');
      }
    },
    [handleError, handleSuccess, sendEmailReeinterview],
  );

  return {
    sendEmailSubscription,
    sendEmailResult,
    enviarEmailReentrevista,
  };
};
